import { ConfigService } from '../../services/config-service';
import { CUSTOM_PAGE_TYPE } from '../constants';

export const getCustomPageTemplateConfiguration = type => {
  switch (type) {
    case CUSTOM_PAGE_TYPE.START_PAGE:
      return {
        ...ConfigService.get('START_PAGE', {})
      };
    case CUSTOM_PAGE_TYPE.RESULT_PAGE:
      return {
        ...ConfigService.get('RESULT_PAGE', {})
      };
    default:
      return {};
  }
};
